var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Iconsvg } from '../iconsvg';
import { componentApi } from '../component-api-lib';
import * as React from 'react';
var Stepthrough = /** @class */ (function (_super) {
    __extends(Stepthrough, _super);
    function Stepthrough() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.templates = [
            { name: 'stepItem', description: 'Accepts items to place in stepthrough' },
        ];
        _this.readTemplate = componentApi.readTemplate.bind(_this);
        return _this;
    }
    Stepthrough.prototype.render = function () {
        var _this = this;
        return (React.createElement("ul", { "data-e2e": this.props.dataE2e, className: 'cg-stepthrough ' +
                (this.isVertical() ? 'cg-is-vertical ' : '') +
                (this.isCompact() ? 'cg-is-compact ' : '') }, Object.values(this.readTemplate('stepItem')).map(function (item, idx) {
            return (React.createElement("li", { "data-e2e": "cg-stepthrough-step", key: 'cogen-19941' + idx.toString(), className: 'cg-stepthrough-step ' +
                    (idx === _this.props.activeIndex ? 'cg-is-active ' : '') +
                    (_this.isFailed(idx) ? 'cg-is-failed ' : '') },
                !_this.isCompact() ? (React.createElement("span", { className: "cg-stepthrough-icon" },
                    idx >= _this.props.activeIndex && !_this.hasStepIcon(idx) ? (React.createElement("span", null, idx + 1)) : null,
                    idx >= _this.props.activeIndex && _this.hasStepIcon(idx) ? (React.createElement(Iconsvg, { name: _this.getStepIcon(idx).name, isFill: _this.getStepIcon(idx).isFilled, isSpin: _this.getStepIcon(idx).isSpin })) : null,
                    _this.props.activeIndex > idx ? (React.createElement(Iconsvg, { name: _this.isFailed(idx) ? 'close' : 'check', isFill: true })) : null)) : null,
                _this.isCompact() ? (React.createElement("span", { className: 'cg-stepthrough-icon ' +
                        (idx === _this.props.activeIndex
                            ? 'cg-stepthrough-icon-active '
                            : '') }, idx === _this.props.activeIndex ? (React.createElement("span", { className: "cg-stepthrough-icon cg-stepthrough-icon-small" })) : null)) : null,
                item));
        })));
    };
    Stepthrough.prototype.isCompact = function () {
        return this.props.mode === 'compact';
    };
    Stepthrough.prototype.isVertical = function () {
        return this.props.alignment === 'vertical';
    };
    Stepthrough.prototype.isFailed = function (idx) {
        return this.props.failedSteps.includes(idx);
    };
    Stepthrough.prototype.hasStepIcon = function (idx) {
        var icons = this.props.stepIcons;
        if (this.props.isCurrentStepLoading && idx === this.props.activeIndex) {
            return true;
        }
        if (icons && icons[idx]) {
            return icons[idx].length > 0;
        }
        return false;
    };
    Stepthrough.prototype.getStepIcon = function (idx) {
        var isCurrentStepLoading = this.props.isCurrentStepLoading;
        if (isCurrentStepLoading && idx === this.props.activeIndex) {
            return {
                name: 'spinner-alt',
                isFilled: true,
                isSpin: true,
            };
        }
        var icon = this.hasStepIcon(idx)
            ? this.props.stepIcons[idx]
            : 'filled-check';
        return {
            name: icon.includes('filled') ? icon.substr(7) : icon,
            isFilled: icon.includes('filled'),
            isSpin: false,
        };
    };
    Stepthrough.prototype.cg_change = function (prevProps) {
        if (prevProps.activeIndex !== this.props.activeIndex) {
            this.getStepIcon(this.props.activeIndex);
        }
    };
    Stepthrough.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.cg_change(__assign(__assign({}, prevProps), prevState));
    };
    Stepthrough.defaultProps = {
        dataE2e: 'cg-stepthrough',
        activeIndex: 0,
        alignment: 'horizontal',
        mode: 'normal',
        failedSteps: [],
        slot: 'stepthrough',
        isCurrentStepLoading: false,
    };
    Stepthrough.displayName = 'Stepthrough';
    return Stepthrough;
}(React.Component));
export { Stepthrough };
